import { Box, CircularProgress } from "@mui/material";
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startValidateExternalApprovalCode, startValidateExternalApprovalCodeInventory, startValidateExternalApprovalCodeAttendance, startValidateExternalApprovalCodeLeave, setIsLoaded } from "./Redux/Slice/commonSlice";
import LinkExpired from "./UI/LinkExpired/LinkExpired";
import RequestApproval from "./Component/Appointment/RequestApproval";
import InventoryApproval from "./Component/Inventory/InventoryApproval";
import SignInComponent from "./Component/mrCalander/signIn";
import axios from "axios";
import AttendanceApproval from "./Component/Attendance/AttendanceApproval";
import LeaveApproval from "./Component/Leave/LeaveApproval";


function App() {
  const dispatch = useDispatch()
  const approvalCode = useSelector(state => state?.common?.approvalCode)
  const isCodeLoaded = approvalCode?.isLoaded
  const isCodeValid = approvalCode?.isValid
  const error = approvalCode?.error
  const purchaseOrderError = useSelector(state => state?.common?.purchaseOrderError)

  const url = new URL(window.location.href)
  const pathname = window.location?.pathname
  const service = url.searchParams.get("service") || "default"

  const handleContextMenu = (e) => {
    e.preventDefault()
  }

  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu)

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)  //After event handler is executed,remove it to prevent memeory leaks
    }
  }, [])

  //clickJacking prevention - frameBusting code
  useEffect(() => {
    if (window !== window.top) {
      window.top.location = window.location
    }
  }, [])

  const handleVisitorService = useCallback((pathname) => {
    axios.get(`${process.env.REACT_APP_VISITOR_URL}v1/csrf`, { withCredentials: true })
      .then((response) => {
        if (response?.status === 200) {
          localStorage.setItem('csrfToken', response?.data?.csrf_token)

          if (pathname !== '/ms/redirect') {        //code related to vms
            const encryptedCode = pathname?.slice(1)
            if (encryptedCode?.length > 0) {
              const data = { encryptedCode }
              dispatch(startValidateExternalApprovalCode(data))
            } else {
              const encryptedCode = localStorage.getItem('encryptedCode')
              const data = { encryptedCode }
              dispatch(startValidateExternalApprovalCode(data))
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [dispatch])

  const handleInventoryService = useCallback((pathname) => {
    axios.get(`${process.env.REACT_APP_INVENTORY_URL}v1/csrf`, { withCredentials: true })
      .then((response) => {
        if (response?.status === 200) {
          localStorage.setItem('csrfToken', response?.data?.csrf_token)

          // Decode URI component for inventory service
          const encryptedCode = decodeURIComponent(pathname?.slice(1))
          const data = { encryptedCode }
          dispatch(startValidateExternalApprovalCodeInventory(data))
        }
      }).catch((error) => {
        console.log(error);
      })
  }, [dispatch])

  const handleAttendanceService = useCallback((pathname) => {
    axios.get(`${process.env.REACT_APP_ATTENDANCE_URL}v1/external/csrf`, { withCredentials: true })
      .then((response) => {
        if (response?.status === 200) {
          localStorage.setItem('csrfToken', response?.data?.csrf_token)
          const encryptedCode = pathname?.slice(1) ? decodeURIComponent(pathname.slice(1)) : localStorage.getItem('encryptedCodeAttendance')
          if (encryptedCode) {
            dispatch(startValidateExternalApprovalCodeAttendance({ encryptedCode }))
          } else {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [dispatch])

  const handleLeaveService = useCallback((pathname) => {
    axios.get(`${process.env.REACT_APP_ATTENDANCE_URL}v1/external/csrf`, { withCredentials: true })
      .then((response) => {
        if (response?.status === 200) {
          localStorage.setItem('csrfToken', response?.data?.csrf_token)
          const encryptedCode = pathname?.slice(1) ? decodeURIComponent(pathname.slice(1)) : localStorage.getItem('encryptedCodeLeave')
          if (encryptedCode) {
            dispatch(startValidateExternalApprovalCodeLeave({ encryptedCode }))
          } else {
            dispatch(setIsLoaded({ isValid: false, error: 'Oops, the link has expired.' }))
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }, [dispatch])

  useEffect(() => {
    if (service) {
      if (service === 'inventory') {
        handleInventoryService(pathname)
      } else if (service === 'attendance') {
        handleAttendanceService(pathname)
      } else if (service === 'leave') {
        handleLeaveService(pathname)
      }
      else {
        handleVisitorService(pathname)
      }
    }
  }, [service, pathname, handleInventoryService, handleVisitorService, handleAttendanceService, handleLeaveService])

  // Check if the path is '/ms/redirect' and return the RedirectComponent
  if (pathname === '/ms/redirect') {
    return <SignInComponent />;
  }

  return (
    <Box sx={{ minHeight: '90vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
      {
        isCodeLoaded ? (
          <Box>
            {isCodeValid
              ? (service === 'inventory'
                ? (<InventoryApproval />)
                : (service === 'attendance'
                  ? (<AttendanceApproval />)
                  : (service === 'leave'
                    ? (<LeaveApproval />)
                    : (<RequestApproval />))))
              : (<LinkExpired error={error} poError={purchaseOrderError} />)}
          </Box>) : (<CircularProgress sx={{ color: "black" }} />)
      }
    </Box>
  );
}

export default App;
